function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getFailOverUrl } from '@kibt/web-utils';
import { addParam } from './yoda'; // 去单个视频页面

export var toWork = function toWork(photoId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.location.href = addParam("ikwai://work/".concat(photoId), params);
}; // 去标签页

export var toHashTag = function toHashTag(tagName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.location.href = addParam("ikwai://tag/topic/".concat(encodeURIComponent(tagName)), params);
}; // 去拍摄

export var toPost = function toPost() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  window.location.href = addParam('ikwai://post', params);
}; // 去音乐

export var toMusic = function toMusic(id) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.location.href = addParam("ikwai://tag/electrical/".concat(id), params);
}; // 去魔表

export var toMagic = function toMagic(id) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.location.href = addParam("ikwai://tag/magicFace/".concat(id), params);
}; // 去模板

export var toMvTemplate = function toMvTemplate(id) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.location.href = addParam('ikwai://tag/mv', _objectSpread({
    id: id
  }, params));
}; // 灵感详情页

export var toInspiration = function toInspiration() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  window.location.href = addParam('kwai://inspiration', params);
}; // 去往他人个人主页

export var toProfile = function toProfile(userId) {
  window.location.href = "ikwai://profile/".concat(userId);
}; // 用ikwai打开一个新webview

export var toWebview = function toWebview(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  url = getFailOverUrl(url);
  window.location.href = "ikwai://webview?url=".concat(encodeURIComponent(addParam(url, params)));
};